import { autoCapitalize } from '@/utils/autoCapitalize'
import { ClinicListData } from './ClinicListMapper.types'

class ClinicListMapper {
  toDomain(persistenceClinicData: ClinicListData) {
    return {
      id: persistenceClinicData?.id,
      name: autoCapitalize(persistenceClinicData?.nome),
    }
  }
}

export default new ClinicListMapper()
